module.exports = __webpack_public_path__ + "static/media/resourcesBack.5bfc3d07.svg";